export default __webpack_public_path__ + "static/media/logo.e4bbf1e8.svg";